<template>
    <div
        class="price-card py-4 px-5 bg-white flex flex-col rounded-2xl"
        :class="{
            'transition-all box-shadow--hover hover:border-green-400 hover:-translate-y-1': linkified,
            'border border-light-300 text-dark-700 font-HKGrotesk-Bold leading-6': !borderless,
        }"
    >
        <div class="flex items-baseline md:items-center justify-between">
            <span class="max-w-[63%] lg:max-w-[80%]">{{ title }}</span>
            <span v-if="price" class="font-HKGrotesk-Bold text-blue text-right w-auto md:w-max">
                <span><T v-if="isPriceFrom && $i18n.locale === 'en'" t="generic.from" /></span>
                {{ getFormattedPrice(price) }}
                <span><T v-if="isPriceFrom & ($i18n.locale === 'hu')" t="generic.from" /></span>
            </span>
            <span v-else class="font-HKGrotesk-Bold text-blue"><T t="generic.free" /></span>
        </div>
        <div
            v-if="description"
            class="price-card-description text-sm font-HKGrotesk-Regular text-dark-200 mt-3"
            :class="{ 'limit-height': linkified }"
            v-html="description"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'ServiceCard',
    props: {
        title: {
            type: String,
            required: true,
        },
        price: {
            type: Number,
            required: false,
            default: null,
        },
        description: {
            type: String,
            required: false,
            default: null,
        },
        isPriceFrom: {
            type: Number,
            required: false,
            default: 0,
        },
        borderless: {
            type: Boolean,
            required: false,
            default: false,
        },
        linkified: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped>
.box-shadow--hover {
    &:hover {
        box-shadow: 0 4px 30px rgb(28 130 150 / 10%);
    }
}
</style>

<style>
.price-card-description.limit-height {
    * {
        display: none;
    }
    p:first-of-type,
    span:first-of-type {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3; /* number of lines to show */
        line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
</style>
